import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/App";
import { RootErrorBoundary } from "@/components/RootErrorBoundary";
import { setupI18n } from "@/i18n";
import { useAuthStore } from "@/stores/authStore";
import { warnIfOriginNotAllowed } from "@/utils/env";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failCount, err) => failCount < 2 && err instanceof Error,
    },
  },
});

async function main() {
  warnIfOriginNotAllowed();
  await setupI18n();
  await useAuthStore.getState().bootstrapFromRefresh();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <RootErrorBoundary>
        <QueryClientProvider client={qc}>
          <App />
        </QueryClientProvider>
      </RootErrorBoundary>
    </StrictMode>
  );
}

void main();
